/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class IssueMutedNotificationArguments {
  /**
  * The name of the control
  */
  'controlName'?: string;
  /**
  * The id of the provider resource
  */
  'providerResourceId'?: string;
  /**
  * Whether the control is muted
  */
  'muted'?: boolean;
  /**
  * The name of the resource
  */
  'resourceName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "controlName",
      "baseName": "controlName",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerResourceId",
      "baseName": "providerResourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "muted",
      "baseName": "muted",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "resourceName",
      "baseName": "resourceName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return IssueMutedNotificationArguments.attributeTypeMap;
  }

  public constructor() {
  }
}

